import { useState } from 'react'

import Chats from 'share-ui/components/Icon/Icons/components/Chats'
import styled from 'styled-components'
import { BurgerMenuOutline } from 'share-ui/components/Icon/Icons'
import IconButton from 'share-ui/components/IconButton/IconButton'
import { Chat, ChatHistory } from './useChatHistory'
import ListCard from 'components/ListCard'
import HistoryPlaceholder from './HistoryPlaceholder'

const ChatHistoryList = ({
    onNewChat,
    chatHistory,
    handleDeleteHistory,
    setChat,
    chat,
}: {
    onNewChat: () => void
    chatHistory: ChatHistory
    handleDeleteHistory: (id: string) => void
    setChat: (chat: Chat) => void
    chat: Chat
}) => {
    const [isVisible, setIsVisible] = useState(false)

    const handleSetChat = (chat: Chat) => {
        setChat(chat)
        setIsVisible(false)
    }

    const handleNewChat = () => {
        onNewChat()
        setIsVisible(false)
    }

    return (
        <>
            <StyledButtonWrapper>
                <IconButton
                    onClick={() => setIsVisible(!isVisible)}
                    icon={() => <BurgerMenuOutline size={40} />}
                    size={IconButton.sizes?.SMALL}
                    kind={IconButton.kinds?.TERTIARY}
                    ariaLabel={isVisible ? 'Close sidebar' : 'Open sidebar'}
                />

                {isVisible && (
                    <IconButton
                        onClick={handleNewChat}
                        icon={() => <StyledChatIcon size={22} />}
                        size={IconButton.sizes?.SMALL}
                        kind={IconButton.kinds?.TERTIARY}
                        ariaLabel='New chat'
                    />
                )}
            </StyledButtonWrapper>

            {isVisible && (
                <StyledHistory>
                    <StyledBody>
                        {chatHistory?.length > 0 &&
                            chatHistory?.map((item: Chat, index: number) => {
                                return (
                                    <>
                                        <ListCard
                                            // icon={<Doc size={24} />}
                                            key={index}
                                            onClick={() => handleSetChat(item)}
                                            name={
                                                item.messages[0]?.prompt ||
                                                item.messages[0].message ||
                                                ''
                                            }
                                            picked={chat.id === item.id}
                                            onDeleteClick={() => handleDeleteHistory(item.id)}
                                        />
                                    </>
                                )
                            })}
                    </StyledBody>

                    {chatHistory?.length === 0 && <HistoryPlaceholder item={'chat'} />}
                </StyledHistory>
            )}
        </>
    )
}

export default ChatHistoryList

export const StyledHistory = styled.div`
    max-width: 250px;
    min-width: 250px;
    height: 100%;

    overflow: auto;

    background: ${({ theme }) => theme.body.cardBgColor};
    box-shadow: ${({ theme }) => theme.body.boxShadow};

    border-radius: 8px;

    display: flex;
    flex-direction: column;

    padding: 20px;

    padding-top: 40px;
`

const StyledChatIcon = styled(Chats)`
    path {
        stroke: ${({ theme }) => theme.body.textColorPrimary};
    }
`
const StyledBody = styled.div`
    margin-top: 16px;

    gap: 4px;
`
const StyledButtonWrapper = styled.div`
    position: absolute;

    display: flex;

    max-width: 250px;
    min-width: 250px;

    justify-content: space-between;

    padding: 5px 18px;
`
